export default __webpack_public_path__ + "static/media/lavaLogo.aaea8dd4.svg";